import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Homepage from "./Homepage";
import { Box } from "@mui/material";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import AboutUs from "./AboutUs";
import { useEffect } from "react";
import ContactUs from "./ContactUs";
import PageNotFound from "./PageNotFound";
import Products from "./Products";
import { DeveloperTools } from "./developer/DeveloperTools";
import { Base64Tool } from "./developer/tools/Base64Tool";
import { UrlTool } from "./developer/tools/UrlTool";
import { HexTool } from "./developer/tools/HexTool";
import { RandomBytesTool } from "./developer/tools/RandomBytesTool";



const ScrollToTop = (props: any) => {
    const location = useLocation();
    useEffect(() => window.scrollTo(0, 0), [ location ]);
  
    return (
        <>
            {props.children}
        </>
    );
};
  

const PageContents = () => {
	const location = useLocation();
	const isToolsPage = /^\/developer\/tools(?:\/|$)/.test(location.pathname);
	const needsReload = isToolsPage !== (document.documentElement.dataset.developerTools === "true");
	useEffect(() => {
		// Reload at the tools boundary to isolate inputs and retain the marketing site's resources.
		if(needsReload) window.location.replace(location.pathname);
	}, [ needsReload, location.pathname ]);
	if(needsReload) return null;
	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginBottom: '20px', minHeight: '500px' }}>
			<ScrollToTop>
				<Routes>
					<Route path="/" element={ <Homepage /> } />
					<Route path="/about" element={ <AboutUs /> } />
					<Route path="/products" element={ <Products /> } />
					<Route path="/contact-us" element={ <ContactUs /> } />
					<Route path="/developer/tools" element={ <DeveloperTools /> } />
					<Route path="/developer/tools/base64" element={ <Base64Tool /> } />
					<Route path="/developer/tools/url" element={ <UrlTool /> } />
					<Route path="/developer/tools/hex" element={ <HexTool /> } />
					<Route path="/developer/tools/random-bytes" element={ <RandomBytesTool /> } />
					<Route path="*" element={ <PageNotFound /> } />
				</Routes>
			</ScrollToTop>
		</Box>
	);
};


export default () => (
    <Router>
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
        }}>
            <Navigation />
            <PageContents />
            <Footer />
        </Box>
    </Router>
);
